module.exports = __webpack_public_path__ + "static/img/patrick-chindo.b9d3c02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/patrick-chindo.png
// module id = r4X5
// module chunks = 0